<div class="flex flex-col w-full h-full bg-white overflow-y-auto md:overflow-hidden thin-scroll relative" [@rise]>
  @if (isLoading()) {
    <div class="absolute inset-0 z-[3] flex items-center justify-center bg-white">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  }

  <button
    matDialogClose
    type="button"
    class="absolute top-[20px] right-[20px] w-[32px] z-[2] h-[32px] rounded-full bg-white/[0.12] md:bg-[#f5f7f7] border-none cursor-pointer flex items-center justify-center text-[11px] font-semibold transition-colors hover:bg-white/20 md:hover:bg-[#e8ebeb]"
  >
    <mat-icon svgIcon="close" class="!w-full !h-auto max-w-[10px] max-h-[10px] text-white md:text-[#6B7D82]"></mat-icon>
  </button>

  <aside class="relative shrink-0 w-full md:w-[340px] h-auto md:self-stretch bg-[#0f3d3b] overflow-visible md:overflow-hidden flex flex-col gap-[14px] md:gap-6">
    <div class="absolute pointer-events-none z-[0] flex items-center justify-center
              w-[260px] h-[260px] -left-[80px] top-[430px]">

      <div class="absolute w-full h-full rounded-full border border-[#66E6B3]/[0.08]"></div>

      <div class="w-[180px] h-[180px] rounded-full border border-[#66E6B3]/[0.12]"></div>

    </div>

    <div class="relative z-[1] flex flex-col gap-[6px] md:gap-6 md:flex-1 md:min-h-0 px-5 py-[20px] md:py-10 md:px-[36px] md:pb-9">
      <p class="!m-0 text-[#A7F3D0] text-[11px] leading-[1.2] font-bold tracking-[0.88px] uppercase">Welcome Bonus</p>
      <h2 class="!m-0 flex-1 text-white !text-[44px] !font-bold leading-none">{{ rewardAmount() }} USDT</h2>
      <p class="!m-0 text-[#C7EBDB] text-[14px] font-medium">credited to your balance</p>
    </div>
  </aside>

  <section class="relative flex flex-col flex-1 md:min-h-0 bg-[#f7fafa] md:bg-white">
    <app-bonus-survey-stepper
      class="flex flex-col flex-1 md:min-h-0"
      [surveyId]="data.surveyId"
      (surveyLoaded)="onSurveyLoaded($event)"
      (surveyLoadFinished)="onSurveyLoadFinished()"
    ></app-bonus-survey-stepper>
  </section>
</div>
